<template>
  <el-col class="chart-module" :lg="$root.barWidth">
    <div
      class="sub-view"
      style="min-height: 240px; padding: 0; text-align: center"
    >
      <el-row style="background-color: #94E3FF; padding: 1px 5px 1px 5px; color: #125478">
        <span style="font-weight: bold; font-size: 13px; float: left">{{
          displayTitle
        }}</span>
        <i
          class="el-icon-close"
          v-if="$root.editMode"
          @click="$root.realTimeOnClose(title)"
        ></i>
        <i
          class="el-icon-zoom-in"
          v-else
          @click="
            $root.showPopUp(displayTitle, $root.chatAnswerStatusChartoption)
          "
        ></i>
      </el-row>
      <el-row>
        <echarts
          :autoresize="true"
          class="chart-view"
          :option="$root.chatAnswerStatusChartoption"
          style="height: 25vh !important; min-height: 200px"
        />
      </el-row>
    </div>
  </el-col>
</template>

<script>
import api from "@/api";
export default {
  name: "ChatAnswerStatusChart",
  props: ["title", "displayTitle"],
  data() {
    return {};
  },
  created() {
    this.getChatAnswerStatus();
  },
  methods: {
    getChatAnswerStatus: function () {
      let that = this;
      api.getChatAnswerStatus().then(
        (res) => {
          if (res && res.data) {
            let data = res.data;
            if (data.dataFlg) {
              that.$root.chatAnswerStatusChartoption = {
                tooltip: {
                  trigger: "item",
                  formatter: "{b} : {c} ({d}%)",
                },
                series: [
                  {
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "47%"],
                    data: data.output_list,
                    labelLine: {
                      length: 3
                    },
                    itemStyle: {
                      emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                      },
                    },
                    color: [
                      "#dc3545",
                      "#ffc107",
                      "#BBBB00",
                      "#67C23A",
                      "#007bff",
                      "#888888",
                    ],
                  },
                ],
              };
            } else {
              that.$root.chatAnswerStatusChartoption = {
                tooltip: {
                  trigger: "item",
                  formatter: "{b} : {c} ({d}%)",
                },
                series: [
                  {
                    type: "pie",
                    radius: "55%",
                    center: ["50%", "47%"],
                    data: data.output_list,
                    labelLine: {
                      length: 3
                    },
                    itemStyle: {
                      emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: "rgba(0, 0, 0, 0.5)",
                      },
                    },
                    color: ["#DDDDDD"],
                  },
                ],
              };
            }
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>
<style>
.el-dialog__title {
  color: #ffffff;
}
</style>
